import React, { useContext, useState } from 'react';
import { UserSessionContext } from 'src/context/UserSessionContext';
import { PERMISSION_BASIC, PERMISSION_ELEVATED } from 'src/constants';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Container, Paper, TextField, useTheme } from '@mui/material';
import { useAlertSnackBar } from 'src/hooks/useAlertSnackBar';
import { AlertSnackBarSeverity } from 'src/constants';
import AlertSnackBar from 'src/components/AlertSnackBar/AlertSnackBar';

export const Login: React.FC = () => {
  const navigate = useNavigate();
  const { user, setUser } = useContext(UserSessionContext);
  const [usernameEmailInput, setUsernameEmailInput] = useState('')
  const [passwordInput, setPasswordInput] = useState('')
  const [userNameInput, setUserNameInput] = useState('')
  const theme = useTheme()
  const {
    alertSnackBarOpen,
    alertSnackBarDuration,
    alertSnackBarSeverity,
    alertSnackBarMessage,
    openAlertSnackBar,
    setAlertSnackBarOpen,
  } = useAlertSnackBar();

  // TODO: still deciding if it's better to use {} as User as the initial object or if I should extend the User interface with a class to initialize all the of the required values?
  //    TODO: I'm just worried about the validation checking in general. I feel more secure with checking if a user.id === undefined rather than if user.id === -1 to give access to the application routes. a user can assign a value of -1 but they can't assign a value of undefined??
  // this really isn't how you shouldn't implement login. This is implemented to show how permissions guarding works, but you can modify it to your needs.
  const handleLogin = (userName: string) => {
    setUser({
      id: '1',
      name: userName,
      roles: ['user'],
    });
    navigate('/home');
  };

  const userAuthInfoNotification =
    'Just Input Your Name And Sign In. User Authentication Feature Currently Under Development.';

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '67vh',
      }}
    >
      {typeof user?.id !== 'undefined' ? (
        <>
          <h1>
            Hi {user.name}!! Looks like you're already logged in! If you want,
            you can access any of the other pages OR logout!
          </h1>
        </>
      ) : (
        <Paper
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            margin: '32px 0',
            width: '80vw',
            padding: '16px',
          }}
        >
          <TextField
            size='medium'
            label='Your Name'
            fullWidth
            value={userNameInput}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setUserNameInput(event.target.value);
            }}
          />
          <TextField
            size='medium'
            label='Your Username or E-mail'
            disabled
            fullWidth
            value={usernameEmailInput}
            onClick={() => {
              openAlertSnackBar(
                6000,
                AlertSnackBarSeverity.INFO,
                userAuthInfoNotification,
              );
            }}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setUsernameEmailInput(event.target.value);
            }}
          />
          <TextField
            size='medium'
            label='Your Password'
            disabled
            fullWidth
            value={passwordInput}
            onClick={() => {
              openAlertSnackBar(
                6000,
                AlertSnackBarSeverity.INFO,
                userAuthInfoNotification,
              );
            }}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setPasswordInput(event.target.value);
            }}
          />
          <Button
            size='large'
            variant='contained'
            fullWidth
            onClick={() => {
              if (userNameInput.trim().length === 0) {
                openAlertSnackBar(
                  6000,
                  AlertSnackBarSeverity.ERROR,
                  'Input A Name',
                );
                return;
              }
              handleLogin(userNameInput);
            }}
          >
            Sign In
          </Button>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
            }}
          >
            <Button
              sx={{
                textTransform: 'none',
                fontSize: theme.typography.body2,
                color: theme.palette.primary.main,
              }}
              onClick={() => {
                openAlertSnackBar(
                  6000,
                  AlertSnackBarSeverity.INFO,
                  userAuthInfoNotification,
                );
              }}
            >
              Forgot username or password?
            </Button>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                fontSize: theme.typography.body2,
              }}
            >
              Don't have an account?
            </Box>
            <Button
              sx={{
                textTransform: 'none',
                fontSize: theme.typography.body2,
                color: theme.palette.primary.main,
              }}
              onClick={() => {
                openAlertSnackBar(
                  6000,
                  AlertSnackBarSeverity.INFO,
                  userAuthInfoNotification,
                );
              }}
            >
              Create account now.
            </Button>
          </Box>
          <AlertSnackBar
            openState={alertSnackBarOpen}
            toggleOpenState={() => {
              setAlertSnackBarOpen(!alertSnackBarOpen);
            }}
            duration={alertSnackBarDuration}
            severity={alertSnackBarSeverity}
            message={alertSnackBarMessage}
          />
        </Paper>
      )}
    </Box>
  );
};

export default Login;
